































import { mapGetters } from 'vuex';
import { PrimaryButton } from '../survey';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'SurveyWelcome',
  components: {
    PrimaryButton,
  },
  computed: {
    ...mapGetters('participant', ['survey', 'template', 'clientLogo']),
  },
})
export default class SurveyWelcome extends Vue {
  readonly template!: any;

  get surveyLogo() {
    // TODO: refactor this??
    if (
      this.template &&
      this.template.name.indexOf('Culture Health Check') > -1
    ) {
      return require('@/assets/images/logo-chc-colour.png');
    }
    return require('@/assets/images/logo-culture-diagnostics-colour.png');
  }

  // METHODS
  startSurvey() {
    this.$store.dispatch('participant/startSurvey');
  }
}
